import { render, staticRenderFns } from "./numeroCreation.vue?vue&type=template&id=484242a7&scoped=true&"
import script from "./numeroCreation.vue?vue&type=script&lang=js&"
export * from "./numeroCreation.vue?vue&type=script&lang=js&"
import style0 from "./numeroCreation.vue?vue&type=style&index=0&id=484242a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484242a7",
  null
  
)

export default component.exports